import { render } from "./Project.vue?vue&type=template&id=1227c55b&ts=true"
import script from "./Project.vue?vue&type=script&lang=ts"
export * from "./Project.vue?vue&type=script&lang=ts"

import "./Project.vue?vue&type=style&index=0&id=1227c55b&lang=css"

import exportComponent from "/workspace/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__